export default __webpack_public_path__ + "static/media/404.84f2ce20.jpg";